import MuiButton, {ButtonProps} from '@mui/material/Button';

export const Button = (props: ButtonProps) => {
    return <MuiButton variant='contained' {...props} />
}
